var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatumUhrzeit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "17.2862mm",
    height: "16.5809mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 269 258",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_x0020_-_x0020_Datum_x0020__x002f__x0020_Uhrzeit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M168 60c1,6 2,11 2,17 0,9 -2,18 -4,27l9 0 0 33 -27 0c-2,2 -4,4 -5,6l32 0 0 32 -38 0 0 -27c-2,1 -4,3 -5,4l0 23 -39 0 0 -7c-2,1 -3,1 -5,1l0 89 181 0 0 -198 -101 0zm-36 192l0 0 -39 0 0 -33 39 0 0 33zm0 -38l0 0 -39 0 0 -33 39 0 0 33zm43 38l0 0 -38 0 0 -33 38 0 0 33zm0 -38l0 0 -38 0 0 -33 38 0 0 33zm44 38l0 0 -38 0 0 -33 38 0 0 33zm0 -77l0 0 -38 0 0 -32 38 0 0 32zm0 -38l0 0 -38 0 0 -33 38 0 0 33zm44 115l0 0 -38 0 0 -33 38 0 0 33zm0 -38l0 0 -38 0 0 -33 38 0 0 33zm0 -39l0 0 -38 0 0 -32 38 0 0 32zm0 -38l0 0 -38 0 0 -33 38 0 0 33z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "181,214 219,214 219,181 181,181 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M77 11c20,0 39,9 52,26 22,28 17,70 -12,92 -12,9 -26,14 -40,14 -21,0 -40,-10 -52,-26 -23,-29 -17,-70 12,-92 11,-9 25,-14 40,-14zm0 -11l0 0c-17,0 -33,5 -47,16 -34,26 -40,74 -14,108 15,19 38,29 61,29 16,0 33,-5 47,-15 33,-26 39,-74 14,-108 -16,-20 -38,-30 -61,-30z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "77,72 47,33 38,40 68,79 72,83 75,88 114,58 108,49 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M168 60c1,6 2,11 2,17 0,9 -2,18 -4,27l9 0 0 33 -27 0c-2,2 -4,4 -5,6l32 0 0 32 -38 0 0 -27c-2,1 -4,3 -5,4l0 23 -39 0 0 -7c-2,1 -3,1 -5,1l0 89 181 0 0 -198 -101 0zm-36 192l0 0 -39 0 0 -33 39 0 0 33zm0 -38l0 0 -39 0 0 -33 39 0 0 33zm43 38l0 0 -38 0 0 -33 38 0 0 33zm0 -38l0 0 -38 0 0 -33 38 0 0 33zm44 38l0 0 -38 0 0 -33 38 0 0 33zm0 -77l0 0 -38 0 0 -32 38 0 0 32zm0 -38l0 0 -38 0 0 -33 38 0 0 33zm44 115l0 0 -38 0 0 -33 38 0 0 33zm0 -38l0 0 -38 0 0 -33 38 0 0 33zm0 -39l0 0 -38 0 0 -32 38 0 0 32zm0 -38l0 0 -38 0 0 -33 38 0 0 33z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF6600",
    points: "181,214 219,214 219,181 181,181 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M77 11c20,0 39,9 52,26 22,28 17,70 -12,92 -12,9 -26,14 -40,14 -21,0 -40,-10 -52,-26 -23,-29 -17,-70 12,-92 11,-9 25,-14 40,-14zm0 -11l0 0c-17,0 -33,5 -47,16 -34,26 -40,74 -14,108 15,19 38,29 61,29 16,0 33,-5 47,-15 33,-26 39,-74 14,-108 -16,-20 -38,-30 -61,-30z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0F0F0",
    points: "77,72 47,33 38,40 68,79 72,83 75,88 114,58 108,49 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatumUhrzeit);
export default __webpack_public_path__ + "static/media/Datum_Uhrzeit.665bea7c48f549c12346c8c80f7b587e.svg";
export { ForwardRef as ReactComponent };